import { ModalOverlayProps } from "react-aria-components";
// eslint-disable-next-line
import { ZIndex } from "@/domains/design/constants";

export enum MDSModalZIndex {
  Default = ZIndex.StandardModal,
  AppStoreCrashNotice = ZIndex.AppStoreCrashNotice,
}

export interface IMDSModalProps extends ModalOverlayProps {
  isOpen?: boolean;
  handleClose?: () => void;
  zIndex?: MDSModalZIndex;
}
